import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { HouseLatest } from "./useHouseLatest";
import { SenateLatest } from "./useSenateLatest";
import { useTourMode } from "../../../contexts/TourModeContext";

export interface CongressionalTradesResponse {
  houseTrades: HouseLatest[];
  senateTrades: SenateLatest[];
  ticker: string;
  totalCount: number;
}

export function useCompanyCongressionalTrades(ticker: string) {
  const { isTourMode, getMockData } = useTourMode();

  return useQuery<CongressionalTradesResponse, Error>({
    queryKey: ["companyCongressionalTrades", ticker, isTourMode],
    queryFn: async () => {
      // Return mock data in tour mode
      if (isTourMode) {
        const mockData = getMockData<CongressionalTradesResponse>("congressionalTrades");
        if (mockData) return mockData;
      }
      const { data } = await api.get<CongressionalTradesResponse>("/company-congressional-trades", {
        params: { ticker },
      });
      return data;
    },
    enabled: isTourMode || !!ticker,
    staleTime: isTourMode ? Infinity : 60 * 60 * 1000, // Never stale in tour mode
    gcTime: 2 * 60 * 60 * 1000, // Keep in cache for 2 hours
    retry: (failureCount, error: any) => {
      if (isTourMode) return false;
      // Don't retry on 404 errors (no congressional trades found - this is normal)
      if (error?.response?.status === 404) {
        return false;
      }
      // Retry other errors up to 3 times
      return failureCount < 3;
    },
  });
}
